/**
 * CloseConfirmationModal - Tipo 1: Modal de Confirmación
 *
 * Usa el componente global ConfirmationModal para confirmar salida sin guardar.
 */

import React from 'react';
import { ExitToApp as ExitToAppIcon } from '@mui/icons-material';
import { ConfirmationModal } from '../../ui/Modal';

export interface CloseConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  /** Raise above custom full-screen drawers (SalesModal). */
  dialogZIndex?: number;
}

const CloseConfirmationModal: React.FC<CloseConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  dialogZIndex,
}) => {
  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="¿Seguro que deseas salir?"
      message="Perderás los cambios realizados hasta ahora."
      confirmText="Salir"
      cancelText="Continuar trabajando"
      variant="default"
      icon={<ExitToAppIcon />}
      dialogZIndex={dialogZIndex}
    />
  );
};

export default CloseConfirmationModal;
